import moment from 'moment';

export default class ChildMood {

    static fromData(data) {
        if (!data) {
            return;
        }

        let mood = new ChildMood();
        mood.date = moment(data.date);
        mood.generalMood = data.general_mood;
        mood.eatingBehaviour = data.eating_behaviour;
        mood.sleepingBehaviour = data.sleeping_behaviour;
        mood.bowelMovement = data.bowel_movement;
        mood.comment = data.comment;

        Object.seal(mood);
        return mood;
    }

    toData() {
        return {
            general_mood: this.generalMood,
            eating_behaviour: this.eatingBehaviour,
            sleeping_behaviour: this.sleepingBehaviour,
            bowel_movement: this.bowelMovement,
            comment: this.comment,
        };
    }
}
